/* eslint-disable react/prop-types,react/destructuring-assignment */
import React, { Component } from 'react';
import _ from 'lodash';

import { connect } from 'react-redux';
import { Input, Tabs, Upload, Icon } from 'antd';
import { withRouter } from 'react-router-dom';

import { FormRow } from '../../views/Form';
import ButtonList from '../../views/ButtonList';
import SpottingGroupSingleFieldEntry from '../../views/SpottingGroupSingleFieldEntry';
import Button from '../../views/StyledButton';
import { providers } from '../../store/spottingGroup/spottingGroupReducers';
import TermPreview from '../../views/SpottingGroupTermsPreview';
import { Top, Middle, Bottom, Flyout } from '../../views/Flyout';

const mapStateToProps = (state = {}) => ({
  ...state.users,
  ...state.spottingGroup,
  ...state.modelSpottingGroup,
});

const mapDispatchToProps = dispatch => Object.keys(providers)
  .reduce((dispatcher, name) => ({ ...dispatcher, [name]: (...args) => dispatch(providers[name](...args)) }), {});

const extend = item => connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(item));

export default (bottle) => {
  bottle.factory('SpottingGroupAddGroupContainer', ({
    PREVIEW_INDEX, SINGLE_INDEX, keywordsFromTerms,
  }) => {
    class SpottingGroupAddGroupContainer extends Component {
      get changeName() {
        return (event) => {
          this.props.setAddGroupName(event.target.value);
        };
      }

      get changeTerms() {
        return (event) => {
          if (typeof event === 'string') {
            this.props.setAddGroupTerms(event);
          } else {
            this.props.setAddGroupTerms(_.get(event, 'target.value', ''));
          }
        };
      }

      get tabsClicked() {
        return (key) => {
          this.props.setTabKey(key);
        };
      }

      get activeKey() {
        return this.showHelp ? 'help' : 'preview';
      }

      get uploadProps() {
        const setAddGroupTerms = this.props.setAddGroupTerms;
        const addingGroupTerms = this.props.addingGroupTerms;
        return {
          beforeUpload: () => false,
          showUploadList: false,
          accept: '.csv',
          onChange(info) {
            const reader = new FileReader();
            reader.onload = () => {
              const data = reader.result;
              const str = data.toString();
              const terms = keywordsFromTerms(str);
              setAddGroupTerms(`${addingGroupTerms}\n${terms.join('\n')}`);
            };
            reader.readAsText(info.file);
          },
        };
      }

      render() {
        return (
          <Flyout>
            <Top>{window.FileReader && (
              <ButtonList line={false} compact={1} style={({ marginBottom: '0.5rem' })}>
                <Upload {...this.uploadProps}>
                  <Button>
                    <Icon type="upload" /> Import Spotting Group CSV
                  </Button>
                </Upload>
              </ButtonList>

            )}
              <FormRow labelSpan={6} label="Name" >
                <Input
                  id="spottingGroupEditingId"
                  value={this.props.addingGroupName}
                  onChange={this.changeName}
                  style={({ width: '100%' })}
                />
              </FormRow>
            </Top>
            <Middle>
              <Tabs tabKey={this.props.tabKey} onChange={this.tabsClicked}>
                <Tabs.TabPane tab="Keyword List" key={PREVIEW_INDEX}>
                  <TermPreview
                    keywords={keywordsFromTerms(this.props.addingGroupTerms)}
                    onChange={this.props.setAddGroupTerms}
                  />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Single Field" key={SINGLE_INDEX}>
                  <SpottingGroupSingleFieldEntry
                    value={this.props.addingGroupTerms}
                    onChange={this.changeTerms}
                  />
                </Tabs.TabPane>
              </Tabs>
            </Middle>
            <Bottom>
              <ButtonList>
                <Button
                  type="primary"
                  disabled={!this.props.canSave}
                  onClick={this.props.save}
                >Save
                </Button>
                <Button onClick={this.props.reset}>Reset</Button>
                <Button onClick={this.props.cancel}>Cancel</Button>
              </ButtonList>
            </Bottom>
          </Flyout>
        );
      }
    }

    return extend(SpottingGroupAddGroupContainer);
  });
};
